import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import type Employee from 'modules/employees/store/models/Employee'

interface Props {
  employee: Employee
  redirect: string
}

const ForwardButton = ({ redirect }: Props) => {
  return <Button.Router to={redirect} type="secondary" iconName="arrow-right" />
}

export default observer(ForwardButton)
